module.exports = __webpack_public_path__ + "static/img/Fancl.faab7d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/Fancl.jpg
// module id = HLS+
// module chunks = 0